import { Directive, ElementRef, HostListener, Input } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';

@Directive({
  selector: '[firebirdWebEllipsisTooltip]',
  providers: [MatTooltip],
  standalone: false,
})
export class EllipsisTooltipDirective {
  @Input() tooltipText!: string;
  @Input() forceTooltip = false;

  constructor(private elementRef: ElementRef, private tooltip: MatTooltip) {}

  @HostListener('mouseover') mouseover() {
    if (
      !this.forceTooltip &&
      this.elementRef.nativeElement.offsetWidth >=
        this.elementRef.nativeElement.scrollWidth
    ) {
      return;
    }
    this.tooltip.message = this.tooltipText;
    this.tooltip.show();
  }
  @HostListener('mouseleave') mouseleave() {
    this.tooltip.hide();
  }
}
